import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgYoutubeLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.457 7.474c-.3-1.173-1.18-2.093-2.299-2.405C22.13 4.5 14 4.5 14 4.5s-8.13 0-10.158.569c-1.119.312-2 1.232-2.3 2.405C1 9.596 1 14.02 1 14.02s0 4.423.543 6.546a3.277 3.277 0 0 0 2.299 2.365C5.87 23.5 14 23.5 14 23.5s8.13 0 10.158-.569a3.285 3.285 0 0 0 2.3-2.365C27 18.443 27 14.02 27 14.02s0-4.424-.543-6.546ZM11.344 18.038v-8.036l6.793 4.018-6.793 4.018Z" />
  </svg>
);
export default SvgYoutubeLogo;
